import { HttpClient } from '@adapters/HttpClient';

export interface ValidateOperatorPinResponse {
  valid: boolean;
}

export class OperatorPinApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async validatePin(pin: string): Promise<ValidateOperatorPinResponse> {
    return this.httpClient.post<ValidateOperatorPinResponse>('/me/operator/unlock-pin/validate', {
      unlock_pin: pin,
    });
  }
}
